var render = function (_h,_vm) {var _c=_vm._c;return _c('footer',{key:_vm.data.key,staticClass:"my-footer"},[_c('h1',[_vm._v("谢谢")])])}
var staticRenderFns = []

export { render, staticRenderFns }